export const preventSubmitOnEnter = (evt: React.KeyboardEvent<HTMLFormElement>) => {
  if (evt.key === 'Enter') {
    const target = evt.target as HTMLElement;
    // Allow Enter inside textarea
    if (target.tagName === 'TEXTAREA') {
      return;
    }
    // Prevent form submission for everything else
    evt.preventDefault();
  }
};

/**
 * Helper to sort array of operational objects by their numberRange number
 * @param items The array to sort
 * @param getNumberRangeNumber how to get the numberRange number in the objects
 * @returns Sorted array by the actual numberRange. Highest entry first
 */
export const sortByNumberRangeNumber = <T>(
  items: T[],
  getNumberRangeNumber: (item: T) => string | undefined | null,
): T[] =>
  [...items].sort((a, b) => {
    const rangeA: string | undefined | null = getNumberRangeNumber(a);
    const rangeB: string | undefined | null = getNumberRangeNumber(b);
    if (!rangeA) return 1;
    if (!rangeB) return -1;

    return Number(rangeB.split('-')[1]) - Number(rangeA.split('-')[1]);
  });
